// Modern Premium Theme - JavaScript
// Award-winning interactions and animations

// ============================================
// CART FUNCTIONALITY
// ============================================

document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('cart-drawer');
  const panelBody = cartDrawer ? cartDrawer.querySelector('.cart-drawer__panel-body') : null;

  // Update cart count in header (icon + number) with count-up animation
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countEls = document.querySelectorAll('.cart-count');
        const next = cart.item_count;
        countEls.forEach(el => {
          const prev = parseInt(el.textContent || '0', 10);
          if (prev !== next && typeof animateCount === 'function') {
            animateCount(el, prev, next, 240);
          } else {
            el.textContent = next;
          }
          el.classList.toggle('cart-count--zero', next === 0);
        });
      })
      .catch(() => {});
  }

  // Refresh cart drawer body HTML via Section Rendering API
  // Preserves the scroll container to avoid scroll breaking after DOM replace (browser layout bug)
  function refreshCartDrawer() {
    if (!panelBody) return Promise.resolve();
    const url = window.location.pathname + '?sections=cart-drawer-content';
    return fetch(url)
      .then(response => response.json())
      .then(data => {
        const html = data['cart-drawer-content'];
        if (typeof html !== 'string') return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const root = doc.body.firstElementChild;
        if (!root) {
          panelBody.innerHTML = html;
          return;
        }
        const newScroll = root.querySelector('.cart-drawer__scroll');
        const newFooter = root.querySelector('.cart-drawer__footer');
        const newEmpty = root.querySelector('.cart-drawer__body--empty');
        const existingScroll = panelBody.querySelector('.cart-drawer__scroll');
        const existingFooter = panelBody.querySelector('.cart-drawer__footer');
        const existingEmpty = panelBody.querySelector('.cart-drawer__body--empty');
        // If both have items: update content only, preserve scroll container
        if (newScroll && newFooter && existingScroll && existingFooter) {
          existingScroll.innerHTML = newScroll.innerHTML;
          existingFooter.innerHTML = newFooter.innerHTML;
        } else if (newEmpty && existingEmpty) {
          existingEmpty.innerHTML = newEmpty.innerHTML;
        } else {
          // Structure changed (items <-> empty): full replace
          panelBody.innerHTML = root.innerHTML;
        }
      })
      .catch(() => {});
  }

  // Add to cart form handling with AJAX
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalText = button ? button.textContent : '';

      if (button) {
        button.textContent = 'Adding...';
        button.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          updateCartCount();
          refreshCartDrawer().then(function () {
            if (cartDrawer) {
              cartDrawer.classList.add('cart-drawer--open');
              cartDrawer.setAttribute('aria-hidden', 'false');
              document.body.classList.add('cart-drawer-open');
              var closeBtn = cartDrawer.querySelector('.cart-drawer__close');
              if (closeBtn) closeBtn.focus();
            }
          });
          if (button) {
            button.textContent = 'Added!';
            button.style.background = '#4CAF50';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
              button.style.background = '';
            }, 2000);
          }
        })
        .catch(error => {
          console.error('Error:', error);
          if (button) {
            button.textContent = 'Error - Try Again';
            button.disabled = false;
            setTimeout(() => {
              button.textContent = originalText;
            }, 2000);
          }
        });
    });
  });

  // Cart drawer: intercept quantity/remove forms for AJAX with count animation + checkout spinner
  function setCartDrawerCheckoutLoading(loading) {
    const btn = document.getElementById('cart-drawer-checkout-btn');
    if (btn) {
      btn.classList.toggle('is-loading', loading);
    }
  }

  function getCartDrawerRow(key) {
    return document.querySelector('[data-cart-drawer-row][data-item-key="' + key + '"]');
  }

  function animateCount(el, from, to, duration, formatter) {
    if (!el) return;
    formatter = formatter || function (n) { return Math.round(n); };
    const start = performance.now();
    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const val = from + (to - from) * eased;
      el.textContent = formatter(val);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function triggerBadgePulse(badge) {
    if (!badge || typeof gsap === 'undefined') return;
    gsap.fromTo(badge, { scale: 1 }, {
      scale: 1.35,
      duration: 0.2,
      ease: 'power2.out',
      overwrite: true,
      onComplete: function () {
        gsap.to(badge, {
          scale: 1,
          duration: 0.45,
          ease: 'back.out(2.2)',
          overwrite: true
        });
      }
    });
  }

  // Cart drawer: optimistic quantity update + server sync
  function updateCartDrawerQuantity(row, newQty, unitPrice, lineTotalEl, badge, minusBtn) {
    badge.textContent = newQty;
    if (lineTotalEl) {
      lineTotalEl.textContent = '\u20B9' + Math.floor((unitPrice * newQty) / 100);
    }
    if (minusBtn) minusBtn.disabled = newQty <= 1;
    row.querySelectorAll('.cart-drawer__quantity-form input[name="quantity"]').forEach(function (input) {
      var form = input.closest('form');
      var delta = form ? parseInt(form.querySelector('[data-cart-qty-delta]')?.getAttribute('data-cart-qty-delta') || '0', 10) : 0;
      input.value = newQty + delta;
    });
  }

  if (cartDrawer) {
    // Plus/minus: click handlers with optimistic update
    cartDrawer.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-cart-qty-delta]');
      if (!btn) return;
      e.preventDefault();
      const delta = parseInt(btn.getAttribute('data-cart-qty-delta') || '0', 10);
      const row = btn.closest('[data-cart-drawer-row]');
      if (!row) return;
      const key = row.getAttribute('data-item-key');
      const badge = row.querySelector('[data-cart-qty-value]');
      const lineTotalEl = row.querySelector('[data-cart-line-total]');
      const unitPrice = parseInt(row.getAttribute('data-unit-price') || '0', 10);
      const currentQty = parseInt(badge?.textContent || '1', 10);
      let newQty = currentQty + delta;
      if (newQty < 1) return;
      const minusBtn = row.querySelectorAll('.cart-drawer__qty-btn')[0];

      const prevBadge = badge ? badge.textContent : '';
      const prevLineTotal = lineTotalEl ? lineTotalEl.textContent : '';
      const subEl = document.querySelector('[data-cart-drawer-subtotal]');
      const prevSub = subEl ? subEl.textContent : '';
      const prevSubNum = parseInt(prevSub.replace(/[^\d]/g, '') || '0', 10);
      const deltaCents = (newQty - currentQty) * unitPrice;
      if (subEl) subEl.textContent = '\u20B9' + Math.max(0, Math.floor(prevSubNum + deltaCents / 100));

      updateCartDrawerQuantity(row, newQty, unitPrice, lineTotalEl, badge, minusBtn);
      const qtyWrap = row.querySelector('.cart-drawer__quantity');
      if (qtyWrap) {
        qtyWrap.classList.remove('cart-drawer__quantity--flash');
        void qtyWrap.offsetWidth;
        qtyWrap.classList.add('cart-drawer__quantity--flash');
        setTimeout(function () { qtyWrap.classList.remove('cart-drawer__quantity--flash'); }, 400);
      }
      setCartDrawerCheckoutLoading(true);

      const body = 'id=' + encodeURIComponent(key) + '&quantity=' + newQty;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status >= 400) throw new Error(data.description || 'Cart update failed');
          updateCartCount();
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            const sub = document.querySelector('[data-cart-drawer-subtotal]');
            if (sub) sub.textContent = '\u20B9' + Math.floor(cart.total_price / 100);
          });
        })
        .catch(function () {
          if (badge) badge.textContent = prevBadge;
          if (lineTotalEl) lineTotalEl.textContent = prevLineTotal;
          if (minusBtn) minusBtn.disabled = currentQty <= 1;
          row.querySelectorAll('.cart-drawer__quantity-form input[name="quantity"]').forEach(function (input) {
            var form = input.closest('form');
            var d = form ? parseInt(form.querySelector('[data-cart-qty-delta]')?.getAttribute('data-cart-qty-delta') || '0', 10) : 0;
            input.value = currentQty + d;
          });
          const subEl = document.querySelector('[data-cart-drawer-subtotal]');
          if (subEl) subEl.textContent = prevSub;
          document.location.reload();
        })
        .finally(function () { setCartDrawerCheckoutLoading(false); });
    });

    // Remove (quantity 0): form submit via AJAX
    cartDrawer.addEventListener('submit', function (e) {
      const form = e.target;
      if (form && form.action && form.action.indexOf('/cart/change') !== -1) {
        const formData = new FormData(form);
        const quantity = parseInt(formData.get('quantity') || '0', 10);
        e.preventDefault();
        setCartDrawerCheckoutLoading(true);
        fetch('/cart/change.js', { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function () {
            updateCartCount();
            return refreshCartDrawer();
          })
          .catch(function () { document.location.reload(); })
          .finally(function () { setCartDrawerCheckoutLoading(false); });
      }
    });
  }

  // Cart page: checkout button redirect to /checkout
  const cartPageForm = document.querySelector('.cart-page form[action="/cart"]');
  if (cartPageForm) {
    cartPageForm.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.id === 'cart-page-checkout-btn') {
        e.preventDefault();
        window.location.href = '/checkout';
      }
    });
  }

  // Cart page: quantity +/- and remove via Cart API
  function formatPrice(cents) {
    return '\u20B9' + Math.floor(cents / 100);
  }

  function animateCount(el, from, to, duration, formatter) {
    if (!el) return;
    formatter = formatter || function (n) { return Math.round(n); };
    var start = performance.now();
    function tick(now) {
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var val = from + (to - from) * eased;
      el.textContent = formatter(val);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function triggerBadgePulse(badge) {
    if (!badge || typeof gsap === 'undefined') return;
    gsap.fromTo(badge, { scale: 1 }, {
      scale: 1.35,
      duration: 0.2,
      ease: 'power2.out',
      overwrite: true,
      onComplete: function () {
        gsap.to(badge, {
          scale: 1,
          duration: 0.45,
          ease: 'back.out(2.2)',
          overwrite: true
        });
      }
    });
  }

  function getCartRow(key) {
    return document.querySelector('[data-cart-row][data-item-key="' + key + '"]');
  }

  function setCheckoutLoading(loading) {
    var btn = document.getElementById('cart-page-checkout-btn');
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
  }

  function updateCartQuantity(key, quantity) {
    var row = getCartRow(key);
    if (!row) return Promise.reject();
    var badge = row.querySelector('[data-cart-qty-badge]');
    var totalCell = row.querySelector('[data-cart-line-total]');
    var unitPrice = parseInt(row.getAttribute('data-unit-price') || '0', 10);
    var oldQty = badge ? parseInt(badge.textContent || '1', 10) : 0;
    var oldTotalCents = unitPrice * oldQty;
    var newTotalCents = unitPrice * quantity;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: 'id=' + encodeURIComponent(key) + '&quantity=' + quantity
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (badge) {
          animateCount(badge, oldQty, quantity, 280);
          triggerBadgePulse(badge);
        }
        var minusBtn = row.querySelector('[data-cart-qty-minus]');
        if (minusBtn) minusBtn.disabled = quantity <= 1;
        if (totalCell && quantity > 0) {
          animateCount(totalCell, oldTotalCents / 100, newTotalCents / 100, 280, function (n) { return '\u20B9' + Math.round(n); });
        }
        updateCartCount();
        refreshCartDrawer();
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var sub = document.querySelector('[data-cart-subtotal]');
          if (sub) {
            var prev = parseInt(sub.textContent.replace(/[^\d]/g, '') || '0', 10);
            var next = Math.floor(cart.total_price / 100);
            animateCount(sub, prev, next, 320, function (n) { return '\u20B9' + Math.round(n); });
          }
          return data;
        });
      });
  }

  document.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.getAttribute('data-item-key');
      if (!key) return;
      var row = getCartRow(key);
      var badge = row ? row.querySelector('[data-cart-qty-badge]') : null;
      var current = badge ? parseInt(badge.textContent || '1', 10) : 1;
      var next = Math.min(current + 1, 999);
      if (next === current) return;
      this.disabled = true;
      setCheckoutLoading(true);
      updateCartQuantity(key, next).finally(function () {
        btn.disabled = false;
        setCheckoutLoading(false);
      });
    });
  });

  document.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.getAttribute('data-item-key');
      if (!key) return;
      var row = getCartRow(key);
      var badge = row ? row.querySelector('[data-cart-qty-badge]') : null;
      var current = badge ? parseInt(badge.textContent || '1', 10) : 1;
      var next = Math.max(current - 1, 1);
      if (next === current) return;
      this.disabled = true;
      setCheckoutLoading(true);
      updateCartQuantity(key, next).finally(function () {
        btn.disabled = false;
        setCheckoutLoading(false);
      });
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.getAttribute('data-item-key');
      if (!key) return;
      this.disabled = true;
      setCheckoutLoading(true);
      updateCartQuantity(key, 0)
        .then(function () {
          var row = getCartRow(key);
          if (row) row.remove();
          var tbody = document.querySelector('.cart-table tbody');
          if (tbody && tbody.children.length === 0) {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          setCheckoutLoading(false);
        });
    });
  });
});

// ============================================
// SCROLL ANIMATIONS
// ============================================

// Fade in elements on scroll (optional - disabled for product cards to prevent flicker)
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('fade-in');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

// Note: Scroll animations disabled for product cards to prevent flicker
// If you want to enable them, uncomment the code below:
/*
document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    card.style.opacity = '0';
    observer.observe(card);
  });
});
*/

// ============================================
// SMOOTH SCROLL FOR ANCHOR LINKS
// ============================================

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// ============================================
// MOBILE MENU TOGGLE
// ============================================

function initMobileMenu() {
  const menuButton = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      menuButton.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mobile-menu') && !e.target.closest('.mobile-menu-toggle')) {
        mobileMenu.classList.remove('active');
        menuButton.classList.remove('active');
        document.body.classList.remove('menu-open');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initMobileMenu);

// ============================================
// IMAGE LAZY LOADING ENHANCEMENT
// ============================================

if ('loading' in HTMLImageElement.prototype) {
  const images = document.querySelectorAll('img[loading="lazy"]');
  images.forEach(img => {
    img.src = img.dataset.src || img.src;
  });
} else {
  // Fallback for browsers that don't support lazy loading
  const script = document.createElement('script');
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
  document.body.appendChild(script);
}

// ============================================
// PRODUCT IMAGE ZOOM (Disabled)
// ============================================

/*
function initImageZoom() {
  const mainImage = document.querySelector('.main-image');
  if (mainImage) {
    mainImage.addEventListener('mousemove', (e) => {
      const { left, top, width, height } = mainImage.getBoundingClientRect();
      const x = ((e.clientX - left) / width) * 100;
      const y = ((e.clientY - top) / height) * 100;
      mainImage.style.transformOrigin = `${x}% ${y}%`;
    });

    mainImage.addEventListener('mouseenter', () => {
      mainImage.style.transform = 'scale(1.5)';
      mainImage.style.cursor = 'zoom-in';
    });

    mainImage.addEventListener('mouseleave', () => {
      mainImage.style.transform = 'scale(1)';
    });
  }
}

document.addEventListener('DOMContentLoaded', initImageZoom);
*/

// ============================================
// PERFORMANCE OPTIMIZATION
// ============================================

// Preload critical resources
window.addEventListener('load', () => {
  // Preload next page images for faster navigation
  const links = document.querySelectorAll('a[href*="/products/"]');
  links.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const href = link.getAttribute('href');
      if (href) {
        const preloadLink = document.createElement('link');
        preloadLink.rel = 'prefetch';
        preloadLink.href = href;
        document.head.appendChild(preloadLink);
      }
    }, { once: true });
  });
});

// ============================================
// KEYBOARD NAVIGATION ENHANCEMENT
// ============================================

document.addEventListener('keydown', (e) => {
  // ESC to close mobile menu
  if (e.key === 'Escape') {
    const mobileMenu = document.querySelector('.mobile-menu');
    if (mobileMenu && mobileMenu.classList.contains('active')) {
      mobileMenu.classList.remove('active');
      document.body.classList.remove('menu-open');
    }
  }
});

// ============================================
// PROMO STRIP ARROW ANIMATION (GSAP)
// ============================================

function initPromoStripArrows() {
  if (typeof gsap === 'undefined') return;
  const cells = document.querySelectorAll('.promo-strip .promo-strip__cell');
  cells.forEach(function (cell) {
    const row = cell.querySelector('.promo-strip__price-row');
    const wrap = cell.querySelector('.promo-strip__arrow-wrap');
    if (!row || !wrap) return;
    cell.addEventListener('mouseenter', function () {
      const price = cell.querySelector('.promo-strip__price');
      let maxW = row.offsetWidth - (price ? price.offsetWidth : 0) - 8;
      if (maxW < 48) maxW = 48;
      gsap.to(wrap, { width: maxW, duration: 0.5, ease: 'power2.out', overwrite: true });
    });
    cell.addEventListener('mouseleave', function () {
      gsap.to(wrap, { width: 48, duration: 0.4, ease: 'power2.in', overwrite: true });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPromoStripArrows);
} else {
  initPromoStripArrows();
}

